import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { UploadMetadata } from '../types/backend-dto-types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetUploadHistory = (caseId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<UploadMetadata[]>(
    [QueryEntity.UploadHistory, caseId],
    () => {
      return fetch(`${APIBaseChronos}/api/case/${caseId}/upload-metadata`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    {
      enabled: !!caseId,
      refetchOnWindowFocus: false,
    },
  );
};
